import React, { Component } from "react";
import StepOne from "./StepOne";
import StepTwo from "./StepTwo";
import StepThree from "./StepThree";
import StepFour from "./StepFour";

import swal from "sweetalert";

import firebase from "../../firebase";
import { auth, database } from "../../firebase";

export default class Steps extends Component {
  state = {
    subject: "",
    schedule: "5",
    interest: [],
    currentComponent: 1,
    about: []
  };

  componentDidMount() {}
  selectSubject = subject => {
    this.setState({ subject: subject });
  };
  selectSchedule = schedule => {
    this.setState({ schedule: schedule });
  };
  selectInterest = interest => {
    this.setState({ interest: interest });
  };

  onNext = () => {
    if (this.state.subject !== "" && this.state.currentComponent === 1) {
      this.setState({ currentComponent: 2 });
    } else if (
      this.state.schedule !== "" &&
      this.state.currentComponent === 2
    ) {
      this.setState({ currentComponent: 3 });
    } else if (
      this.state.interest !== [] &&
      this.state.currentComponent === 3
    ) {
      this.setState({ currentComponent: 4 });
    } else if (this.state.about !== [] && this.state.currentComponent === 4) {
    }
  };

  onRegister = about => {
    var email = about.email;
    var password = about.password;

    auth
      .createUserWithEmailAndPassword(email, password)
      .then(data => {
        var docRef = database.collection("user_master").doc(data.user.uid);

        this.setState({ userId: data.user.uid });

        var docData = {
          created_any_course: false,
          email_address: about.email,
          is_verified: about.verified,
          mobile_no: about.mobileNumber,
          pancard_verified: "no",
          preferred_lan_id: "LNG_01",
          register_as: "trainer",
          register_date: new Date(),
          user_current_status: "offline",
          user_first_name: about.firstName,
          user_group_id: null,
          user_id: data.user.uid,
          user_image: null,
          user_last_name: about.lastName,
          user_name: "",
          user_password: about.password
        };

        docRef
          .set(docData)
          .then(doc => {
            this.setState({ currentComponent: 5 });

            this.addTrainerProperties(about);
          })
          .catch(error => {
            console.log("Error getting document:", error);
          });
      })
      .catch(error => {
        console.log(error);
      });
  };

  addTrainerProperties = about => {
    var docRef = database
      .collection("trainer_properties")
      .doc(this.state.userId);

    var docData = {
      subject: this.state.subject,
      schedule: this.state.schedule,
      interest: this.state.interest,
      about: about.aboutMe,
      education_type: about.educationType,
      degree: about.degree
    };

    docRef
      .set(docData)
      .then(doc => {
        console.log("Trainer properties added");
      })
      .catch(error => {
        console.log("Error getting document:", error);
      });
  };

  previous = () => {
    let currentComponent = this.state.currentComponent;
    if (currentComponent > 1) {
      this.setState({ currentComponent: currentComponent - 1 });
    }
  };
  render() {
    const currentComponent = this.state.currentComponent;
    return (
      <div className="pt-3">
        <div className="container selection-container">
          <div className="stepper row mt-5 mb-3 d-flex justify-content-around mx-auto">
            <div className="col p-0 text-center">
              <h5
                className={
                  currentComponent > 0 ? "text-primary" : "text-secondary"
                }
              >
                Subjects
              </h5>
            </div>
            <div
              className="col p-0 text-center"
              className={
                currentComponent > 1 ? "text-primary" : "text-secondary"
              }
            >
              <i class="fas fa-long-arrow-alt-right" />
            </div>
            <div className="col p-0 text-center">
              <h5
                className={
                  currentComponent > 1 ? "text-primary" : "text-secondary"
                }
              >
                Schedule
              </h5>
            </div>
            <div
              className="col p-0 text-center"
              className={
                currentComponent > 2 ? "text-primary" : "text-secondary"
              }
            >
              <i class="fas fa-long-arrow-alt-right" />
            </div>
            <div className="col p-0 text-center">
              <h5
                className={
                  currentComponent > 2 ? "text-primary" : "text-secondary"
                }
              >
                About You
              </h5>
            </div>
          </div>
          <div className="step card card-body">
            {this.state.currentComponent === 1 ? (
              <StepOne
                selectSubject={this.selectSubject}
                subject={this.state.subject}
              />
            ) : this.state.currentComponent === 2 ? (
              <StepTwo selectSchedule={this.selectSchedule} />
            ) : this.state.currentComponent === 3 ? (
              <StepThree selectInterest={this.selectInterest} />
            ) : this.state.currentComponent === 4 ? (
              <StepFour addAbout={this.addAbout} onRegister={this.onRegister} />
            ) : this.state.currentComponent === 5 ? (
              <div className="d-flex justify-content-center align-items-center flex-column h-100 mt-5">
                <i class="fa fa-check" />
                <h4 className="text-primary">Successfully Registered </h4>
              </div>
            ) : (
              ""
            )}
          </div>
          <div className="row py-3">
            {/* <div className="col">
            {this.state.currentComponent > 1 ? (
              <div
                class="btn btn-primary get-started-btn"
                onClick={this.previous}
              >
                Previous
              </div>
            ) : (
              ""
            )}
          </div> */}
            {this.state.currentComponent < 4 ? (
              <div className="col">
                <div
                  class="btn btn-primary get-started-btn float-right"
                  onClick={this.onNext}
                >
                  Next
                </div>
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    );
  }
}
